import {
  KEYCODE_LEFT,
  KEYCODE_RIGHT,
} from 'root/lib/AccessibilityConstants';

export const getPosition = (keyCode, oldPosition) => {
  if (keyCode === KEYCODE_RIGHT) {
    if (oldPosition >= 2) return 2;

    return oldPosition + 1;
  }

  if (keyCode === KEYCODE_LEFT) {
    if (oldPosition <= 0) return 0;

    return oldPosition - 1;
  }

  return oldPosition;
};

const HelperFunctions = {
  /**
   * Sorts the draggable cards array by the order they appear on screen
   * @param {[cards]} draggableCards DraggableCard objects that are stored in the draggableCardReducer
   */
  sortDraggableCardsByOrder(draggableCards) {
    const ordered = Array.from(draggableCards);
    ordered.sort((a, b) => {
      if (a.order >= b.order) {
        return 1;
      }
      return -1;
    });
    return ordered;
  },

  /**
   * Sort cards by their x position. returns array of sorted cards
   * @param {[cards]} draggableCards DraggableCard objects that are stored in the draggableCardReducer
   */
  sortDraggableCardsByXPos(draggableCards) {
    const ordered = Array.from(draggableCards);
    ordered.sort((a, b) => {
      if (a.x >= b.x) {
        return 1;
      }
      return -1;
    });
    return ordered;
  },

  /**
   * Checks if the draggable cards on the screen are in the correct order
   * @param {[cards]} draggableCards DraggableCard objects that are stored in the draggableCardReducer
   * @param {Array.<Object>} cardsContent - a list of the curriculum for the cards in this question item
   */
  checkAnswer(draggableCards, cardsContent) {
    for (let i = 0; i < draggableCards.length; i++) {
      if (draggableCards[i].order !== cardsContent[i].answerIndex) {
        return false;
      }
    }
    return true;
  },

  /**
   * Sorts the draggable cards array by their correct answer order
   * @param {[cards]} phrases phrase objects that are pulled straight from the curriculum
   */
  sortDraggableCardsByAnswerIndex(phrases) {
    const ordered = Array.from(phrases);
    ordered.sort((a, b) => {
      if (a.answerIndex >= b.answerIndex) {
        return 1;
      }
      return -1;
    });
    return ordered;
  },

  /**
   * Calculates number of items to success master criteria.
   * @param {*} number items per level.
   * @param {*} masterCriteria
   * @returns number of items.
   */
  getPercentageOf(number, masterCriteria) {
    return Math.round((number / 100) * masterCriteria);
  },

  /**
   * Checks if the array of phrases are in the correct order already
   * @param {[cards]} phrases phrase objects that are pulled straight from the curriculum
   * These phrases are also the object that is found in the content object of the DraggableCards reducer storage
   */
  checkIfPhrasesAreInCorrectOrder(phrases) {
    for (let i = 0; i < phrases.length; i++) {
      if (phrases[i].answerIndex !== i) {
        return false;
      }
    }
    return true;
  },
};

export default HelperFunctions;
